module.exports = __webpack_public_path__ + "static/media/vrc.de74f516.svg";